import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  multi(variables = {}) {
    return query(operations.MULTI, variables, true);
  },
  fetch(variables = {}) {
    return query(operations.QUIZZES, variables);
  },
  get(variables = {}) {
    return query(operations.QUIZ, variables);
  },
  update(variables = {}) {
    return mutation(operations.QUIZ_UPDATE, variables);
  },
};
